import { useEffect, useState } from 'react'
import Navbar from '../../components/navbar/navbar.jsx'
import CryptoJS from 'crypto-js'
import api from '../../services/api.js'
import 'bootstrap/dist/css/bootstrap.css'
import './estoqueproduto.css'
import React, { useRef } from 'react'

import { Container, Row, Col } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { Modal, Button, Form } from 'react-bootstrap'
import { format } from 'date-fns'
import { Link, useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import moment from 'moment'

import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import apinode from '../../services/apinode.js'

function EstoqueProduto() {
  const [isLoading, setIsLoading] = useState(false)
  const { id_produto } = useParams()
  const [id_item, setItem] = useState('')
  const { id_conta } = useParams()
  const navigate = useNavigate()
  const [dadosproduto, DadosProduto] = useState([])
  const [dadosmov, setMov] = useState([])
  const secretKey = 'mySecretKey'
  const plainText = '1234'
  const encryptedText = CryptoJS.AES.encrypt(plainText, secretKey).toString()
  const [dadosgeren, setGerencial] = useState({})
  const [totaisprod, setTotaisProd] = useState([])

  const [isHidden, setIsHidden] = useState(true)

  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [showModal, setShowModal] = useState(false)
  const handleCloseModal = () => setShowModal(false)
  const handleShowModal = () => setShowModal(true)
  const [tipo, setTipo] = useState('')
  const [origem, setOrigem] = useState('')
  const [dataInicial, setDataInicial] = useState('')
  const [dataFinal, setDataFinal] = useState('')
  const [dataInicialFormatada, setDataInicialFormatada] = useState('')
  const [dataFinalFormatada, setDataFinalFormatada] = useState('')
  const data = new Date(2, 3, 24) // 24/04/0002
  const [loading, setLoading] = useState(false)
  const [tipoe, setTipoe] = useState('')
  const [quantidade, setQuantidade] = useState(0)
  const [precoUnitario, setPrecoUnitario] = useState(0)
  const [custoUnitario, setCustoUnitario] = useState(0)
  const [observacao, setObservacao] = useState('')
  const tabelaRef = useRef(null)
  const [enviando, setEnviando] = useState(false)
  const [isSidebarVisible, setIsSidebarVisible] = useState(true)
  const [showModalCusto, setShowModalCusto] = useState(false)
  const [apiResult, setApiResult] = useState([])
  const [idProd, setIdProd] = useState('')

  function gerarPDF() {
    const doc = new jsPDF()

    // Cabeçalho do PDF
    doc.text('Valores da tabela', 10, 10)

    // Converte a tabela em uma imagem e adiciona ao PDF
    const tabela = document.getElementById('tabela')
    window.setTimeout(() => {
      html2canvas(tabela).then((canvas) => {
        const imgData = canvas.toDataURL('image/png')
        doc.addImage(imgData, 'PNG', 15, 15, 180, 120)
        doc.save('valores.pdf')
      })
    }, 1000)
  }

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible)
  }

  const handleTipoChange = (event) => {
    setTipo(event.target.value)
  }

  const handleQuantidadeChange = (event) => {
    setQuantidade(event.target.value)
  }

  const handlePrecoUnitarioChange = (event) => {
    setPrecoUnitario(event.target.value)
  }

  const handleCustoUnitarioChange = (event) => {
    setCustoUnitario(event.target.value)
  }

  const handleObservacaoChange = (event) => {
    setObservacao(event.target.value)
  }

  const handleTipoeChange = (event) => {
    setTipoe(event.target.value)
  }

  const handleOrigemChange = (event) => {
    setOrigem(event.target.value)
  }

  const handleDataInicialChange = (event) => {
    const dataInicial = event.target.value
    const dataInicialFormatada = format(new Date(dataInicial), 'dd/MM/yyyy')
    setDataInicial(dataInicial)
    setDataInicialFormatada(dataInicialFormatada)
  }

  const handleDataFinalChange = (event) => {
    const dataFinal = event.target.value
    const dataFinalFormatada = format(new Date(dataFinal), 'dd/MM/yyyy')
    setDataFinal(dataFinal)
    setDataFinalFormatada(dataFinalFormatada)
  }

  const handleCloseModalCusto = () => {
    setShowModalCusto(false)
  }

  const handleShowModalCusto = () => {
    apinode
      .get(`/custos/${id_produto}/${id_conta}`)
      .then((response) => {
        setLoading(false) // Finalizar indicador de carregamento

        if (response.status === 404) {
          alert('Movimentação de produto não encontrada')
          return false
        } else {
          // Chamar a função DadosProduto passando o array historicoEstoque como argumento

          setApiResult(response.data)

          // Resto do seu código...
        }
      })
      .catch((err) => {
        setLoading(false) // Finalizar indicador de carregamento
        alert('Ops! Ocorreu um erro ao consultar dados do produto: ' + err)
      })
    setShowModalCusto(true)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    // aqui você pode chamar a API passando os valores capturados
  }

  function TelaDeLoading() {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
        <label> Processando...</label>
      </div>
    )
  }

  function SalvarDados() {
    console.log(tipoe)

    if (tipoe === 'Selecione um tipo') {
      alert('Selecione um tipo de operação')
    } else {
      // Verifica se já está enviando o formulário
      if (enviando) {
        return
      }

      // Define o estado de envio como verdadeiro
      setEnviando(true)

      const dados_produto = {
        conta: id_conta,
        sku: id_produto,
        tipo: tipoe,
        quantidade: quantidade,
        valor: precoUnitario,
        custo: custoUnitario,
        tipoOrigem: observacao,
      }

      if (dados_produto.length > 0) {
        swal('Oops', 'Informe todos os campos', 'warning')
        setEnviando(false) // Define o estado de envio como falso
      } else {
        api
          .put('https://mobile.belahome.com.br/atulizaestgen', dados_produto)
          .then((retorno) => {
            console.log(retorno)
            if (retorno.status === 200) {
              swal('Confirmação', 'Realizado com sucesso!', 'success')
              setEnviando(false) // Define o estado de envio como falso
            } else {
              alert('Erro ao processar... contate o suporte!')
              console.log(retorno)
              setEnviando(false) // Define o estado de envio como falso
            }
          })
          .catch((error) => {
            alert('Erro ao processar... contate o suporte!')
            console.log(error)
            setEnviando(false) // Define o estado de envio como falso
          })
      }
    }
  }

  function GetDadosProduto() {
    setLoading(true) // Iniciar indicador de carregamento

    apinode
      .get(`/movimentacoesproduto/${id_produto}/${id_conta}`)
      .then((response) => {
        setLoading(false) // Finalizar indicador de carregamento

        if (response.status === 404) {
          alert('Movimentação de produto não encontrada')
          return false
        } else {
          // Chamar a função DadosProduto passando o array historicoEstoque como argumento
          console.log(response.data)
          DadosProduto(response.data)
          setGerencial(response.data.outroSelect)
          setIdProd(response.data.outroSelect?.CODPRODUTO)
          console.log(response.data.outroSelect[0].QTESTGER)
          setMov(response.data)

          // Resto do seu código...
        }
      })
      .catch((err) => {
        setLoading(false) // Finalizar indicador de carregamento
        alert('Ops! Ocorreu um erro ao consultar dados do produto: ' + err)
      })
  }

  function GetMov(codproduto) {
    api
      .get('https://mobile.belahome.com.br/movimentacoesproduto', {
        params: {
          id_item: codproduto,
          conta: id_conta,
          sku: id_produto,
        },
      })

      .then((response) => {
        if (response.status == 404) {
          alert('pedido não encontrado')
          return false
        } else {
          setTotaisProd(response.data.totalProduto)
          setGerencial(response.data)
          setMov(response.data.dados)
          console.log(response.data)
        }
      })

      .catch((err) => {
        alert('ops! ocorreu um erro ao consultar dados do produto' + err)
      })
  }

  function GetMovFilter(codproduto) {
    setLoading(true)
    api
      .get('/movproduct', {
        params: {
          id_item: codproduto,
          conta: id_conta,
          sku: id_produto,
          datai: dataInicial,
          dataf: dataFinal,
          tipo: tipo,
        },
      })

      .then((response) => {
        if (response.status == 404) {
          alert('Filtro não encontrado')
          setLoading(false)
          setShowModal(false)
          return false
        } else {
          setTotaisProd(response.data.totalProduto)
          setGerencial(response.data)
          setMov(response.data.dados)
          console.log(response.data)
          setLoading(false)
          setShowModal(false)
        }
      })

      .catch((err) => {
        swal('Oops!', 'Pesquisa não retorno nada: ' + err, 'warning')
        setLoading(false)
      })
  }

  useEffect(() => {
    GetDadosProduto()

    // const decryptedText = CryptoJS.AES.decrypt(encryptedText, secretKey).toString(CryptoJS.enc.Utf8);
    // alert(decryptedText)
    // "1234"
  }, [])

  function Table({ data, itemsPerPage }) {
    const [currentPage, setCurrentPage] = useState(1)
    const totalItems = data.length
    const totalPages = Math.ceil(totalItems / itemsPerPage)

    function handlePageClick(pageNumber) {
      setCurrentPage(pageNumber)
    }

    const startIndex = (currentPage - 1) * itemsPerPage
    const slicedData = data.slice(startIndex, startIndex + itemsPerPage)

    return (
      <>
        <table
          className="table"
          style={{ backgroundColor: 'white' }}
        >
          <thead>
            <tr>
              <th
                scope="col"
                style={{ width: '100px' }}
              >
                Tipo
              </th>
              <th
                scope="col"
                style={{ width: '200px' }}
              >
                Detal. origem
              </th>
              <th scope="col">Data</th>
              <th scope="col">Valor</th>
              <th scope="col">Entrada</th>
              <th scope="col">Saída</th>

              <th scope="col">Pedido Origem</th>
            </tr>
          </thead>
          <tbody>
            {slicedData.map((items, index) => {
              const dataLocal = moment.utc(items.DATA).local().toDate()
              const dataFormatada = new Intl.DateTimeFormat('pt-BR', {
                dateStyle: 'short',
              }).format(dataLocal)
              let quantidadeEntrada = 0 // Variável para armazenar a quantidade de entrada
              let quantidadeSaida = 0 // Variável para armazenar a quantidade de saída

              if (items.DESCRICAO === 'Entrada') {
                quantidadeEntrada += items.QUANTIDADE // Adiciona a quantidade de entrada
              } else if (items.DESCRICAO === 'Saída') {
                quantidadeSaida += items.QUANTIDADE // Adiciona a quantidade de saída
              }

              return (
                <tr key={items.id}>
                  <td
                    style={{
                      color: items.DESCRICAO === 'Saída' ? 'red' : 'blue',
                    }}
                  >
                    {items.DESCRICAO}
                  </td>
                  <td>{items.ORIGEM}</td>
                  <td>{dataFormatada}</td>
                  <td>
                    {new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(items.VALOR)}
                  </td>
                  <td>{quantidadeEntrada}</td> // Exibe a quantidade de entrada
                  <td>{quantidadeSaida}</td> // Exibe a quantidade de saída
                  <td>{items.ID_PEDIDO}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageClick={handlePageClick}
        />
      </>
    )
  }

  function Pagination({ currentPage, totalPages, onPageClick }) {
    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1)

    return (
      <ul>
        {pageNumbers.map((pageNumber) => (
          <li key={pageNumber}>
            <button
              onClick={() => onPageClick(pageNumber)}
              disabled={pageNumber === currentPage}
            >
              {pageNumber}
            </button>
          </li>
        ))}
      </ul>
    )
  }

  return (
    <>
      <Navbar />

      <div>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary border-0 d-md-none"
          onClick={toggleSidebar}
        >
          <i className="bi bi-chevron-double-right"></i>
        </button>

        <div
          className={`sidebar rounded-start rounded-end ${
            isSidebarVisible ? '' : 'hide-sidebar'
          }`}
        >
          <ul className="list-unstyled">
            <li className="mb-3">
              <button
                type="button"
                onClick={handleShowModalCusto}
                className="btn btn-sm btn-outline-secondary border-0"
              >
                <i className="bi bi-box-arrow-up-right fs-6"></i>
                <span className="fs-6"> Histórico de custos</span>
              </button>
            </li>
            <li className="mb-3">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary border-0"
              >
                <i className="bi bi-shuffle fs-6"></i>
                <span className="fs-6"> Transferência entre depósitos</span>
              </button>
            </li>
          </ul>

          <div
            id="saldo-geral"
            className="new-side-bar-info hide-on-minimize"
          >
            <div
              className="totais"
              style={{ marginTop: '5px' }}
            >
              {totaisprod.map((items, index) => {
                return (
                  <div key={items.ID}>
                    <span className="text-dark">{items.DESCRICAO}</span>
                    <div
                      className={
                        items.DESCRICAO === 'Saída'
                          ? 'text-danger'
                          : 'text-success'
                      }
                    >
                      {items.TOTAL}
                    </div>
                  </div>
                )
              })}

              <span
                id="saldo_atual_estoque"
                className="text-dark"
              >
                Saldo atual
              </span>
              <div className="text-primary">
                <span id="info_saldo_atual_estoque">
                  <i className="bi bi-boxes">
                    {' '}
                    {dadosgeren[0] && dadosgeren[0].QTESTGER}
                  </i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid mt-page">
        <div className="ms-4 p-sm d-flex justify-content-between">
          <h2>Estoque</h2>
        </div>
        <br />
        <div
          className="text-right"
          style={{ marginRight: '170px' }}
        >
          <Container>
            <Row>
              <Col>
                <div className="text-end">
                  <button
                    className="btn btn-lateral"
                    onClick={handleShow}
                  >
                    <i className="bi bi-plus text-icon"></i>
                    Novo Lançamento
                  </button>
                </div>

                <div className="col 12">
                  {/* <input type="text" id="pesquisa-mini" className="form-control " name="pesquisa-mini" placeholder="Pesquise pela descrição do produto" /> */}

                  <br />
                  <div className="row">
                    <div className="col">
                      <h5>
                        {id_produto &&
                        dadosgeren[0] &&
                        dadosgeren[0].DESCRICAO &&
                        dadosgeren[0].UNIDADE
                          ? id_produto +
                            ' - ' +
                            dadosgeren[0].DESCRICAO +
                            ' - Unidade: ' +
                            dadosgeren[0].UNIDADE
                          : ' '}
                      </h5>
                    </div>

                    <div className="col-12">
                      <div className="float-left mb-3">
                        <button
                          className="btn btn-primary"
                          onClick={handleShowModal}
                        >
                          <i className="bi bi-filter text-icon"></i> Filtrar
                        </button>
                      </div>
                    </div>
                  </div>
                  <br />
                  {loading ? ( // Verifica se isLoading é true
                    <div className="loading">
                      <div className="loading-spinner"></div>
                      {/* <label> Carregando...</label> */}
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th
                              scope="col"
                              style={{ width: '100px', color: 'gray' }}
                            >
                              Tipo
                            </th>
                            <th
                              scope="col"
                              style={{ width: '200px', color: 'gray' }}
                            >
                              Detal. origem
                            </th>
                            <th
                              scope="col"
                              style={{ color: 'gray' }}
                            >
                              Data
                            </th>
                            <th
                              scope="col"
                              style={{ color: 'gray' }}
                            >
                              Valor
                            </th>
                            <th
                              scope="col"
                              style={{ color: 'gray' }}
                            >
                              Custo
                            </th>
                            <th
                              scope="col"
                              style={{ color: 'gray' }}
                            >
                              Entrada
                            </th>
                            <th
                              scope="col"
                              style={{ color: 'gray' }}
                            >
                              Saída
                            </th>
                            <th
                              scope="col"
                              style={{ color: 'gray' }}
                            >
                              Balanço
                            </th>
                            <th
                              scope="col"
                              style={{ color: 'gray' }}
                            >
                              Pedido Origem
                            </th>
                            <th
                              scope="col"
                              style={{ color: 'gray' }}
                            >
                              Detalhes
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {Array.isArray(dadosmov.historicoEstoque)
                            ? dadosmov.historicoEstoque
                                .slice() // Crie uma cópia do array para não afetar o original
                                .sort(
                                  (a, b) => new Date(b.DATA) - new Date(a.DATA),
                                ) // Ordena a lista pela data decrescente
                                .map((item) => {
                                  const data = new Date(item.DATA) // Converte a data para objeto Date

                                  // Cálculo da quantidade de entrada e saída
                                  let quantidadeEntrada = 0.0
                                  let quantidadeSaida = 0.0
                                  let quantidadeBalanco = 0.0

                                  if (item.DESCRICAO === 'Entrada') {
                                    quantidadeEntrada += item.QUANTIDADE // Adiciona a quantidade de entrada
                                  } else if (item.DESCRICAO === 'Saída') {
                                    quantidadeSaida += item.QUANTIDADE // Adiciona a quantidade de saída
                                  } else if (item.DESCRICAO === 'Balanco') {
                                    quantidadeBalanco += item.QUANTIDADE // Adiciona a quantidade de saída
                                  }

                                  return (
                                    <tr key={item.ID}>
                                      <td
                                        style={{
                                          color:
                                            item.DESCRICAO === 'Saída'
                                              ? 'red'
                                              : 'blue',
                                        }}
                                      >
                                        {item.DESCRICAO}
                                      </td>
                                      <td>{item.ORIGEM}</td>
                                      <td>
                                        {item.DATA !== null
                                          ? new Intl.DateTimeFormat('pt-BR', {
                                              dateStyle: 'short',
                                            }).format(new Date(item.DATA))
                                          : 'Data não disponível'}
                                      </td>
                                      <td>
                                        {item.VALOR !== null
                                          ? new Intl.NumberFormat('pt-BR', {
                                              style: 'currency',
                                              currency: 'BRL',
                                            }).format(item.VALOR)
                                          : 'Valor não disponível'}
                                      </td>
                                      <td>
                                        {item.CUSTO !== null
                                          ? new Intl.NumberFormat('pt-BR', {
                                              style: 'currency',
                                              currency: 'BRL',
                                            }).format(item.CUSTO)
                                          : 'Custo não disponível'}
                                      </td>
                                      <td style={{ color: 'blue' }}>
                                        {quantidadeEntrada.toFixed(2)}
                                      </td>
                                      <td style={{ color: 'red' }}>
                                        {quantidadeSaida.toFixed(2)}
                                      </td>
                                      <td style={{ color: 'green' }}>
                                        {quantidadeBalanco.toFixed(2)}
                                      </td>
                                      <td>{item.ID_PEDIDO}</td>
                                      <td>{item.TIPO_ORIGEM}</td>
                                    </tr>
                                  )
                                })
                            : null}
                        </tbody>
                      </table>
                      {dadosmov.length == 0 ? (
                        <div className="no-item">sem movimentações</div>
                      ) : null}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Novo Lançamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formTipo">
              <Form.Label>Tipo</Form.Label>
              <Form.Control
                as="select"
                value={tipoe}
                onChange={handleTipoeChange}
              >
                <option>Selecione um tipo</option>
                <option>Entrada</option>
                <option>Saída</option>
                <option>Balanco</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="formQuantidade">
              <Form.Label>Quantidade</Form.Label>
              <Form.Control
                type="text"
                pattern="\d+(,\d{2})?"
                placeholder="Insira a quantidade"
                value={quantidade}
                onChange={handleQuantidadeChange}
              />
            </Form.Group>

            <Form.Group controlId="formPrecoUnitario">
              <Form.Label>Preço Unitário</Form.Label>
              <Form.Control
                type="text"
                pattern="\d+(,\d{2})?"
                placeholder="Insira o preço unitário"
                value={precoUnitario}
                onChange={handlePrecoUnitarioChange}
              />
            </Form.Group>

            <Form.Group controlId="formCustoUnitario">
              <Form.Label>Custo Unitário</Form.Label>
              <Form.Control
                type="text"
                pattern="\d+(,\d{2})?"
                placeholder="Insira o custo unitário"
                value={custoUnitario}
                onChange={handleCustoUnitarioChange}
              />
            </Form.Group>

            <Form.Group controlId="formObservacao">
              <Form.Label>Observação</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={observacao}
                onChange={handleObservacaoChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={() => SalvarDados()}
            disabled={enviando}
          >
            {enviando ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              'Incluir'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        dialogClassName="modal-side"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Filtrar por tipo e data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <form onSubmit={handleSubmit}>
              <Form.Group controlId="formTipo">
                <Form.Label>Tipo</Form.Label>
                <Form.Control
                  as="select"
                  value={tipo}
                  onChange={handleTipoChange}
                >
                  <option>Selecione um tipo</option>
                  <option>Entrada</option>
                  <option>Saída</option>
                  <option>Balanço</option>
                </Form.Control>
              </Form.Group>

              <Form.Group controlId="formOrigem">
                <Form.Label>Origem</Form.Label>
                <Form.Control
                  as="select"
                  value={origem}
                  onChange={handleOrigemChange}
                >
                  <option>Selecione uma origem</option>
                  <option>Venda</option>
                </Form.Control>
              </Form.Group>

              <Form.Group controlId="formDataInicial">
                <Form.Label>Data Inicial</Form.Label>
                <Form.Control
                  type="date"
                  value={dataInicial}
                  onChange={handleDataInicialChange}
                />
              </Form.Group>

              <Form.Group controlId="formDataFinal">
                <Form.Label>Data Final</Form.Label>
                <Form.Control
                  type="date"
                  value={dataFinal}
                  onChange={handleDataFinalChange}
                />
              </Form.Group>
            </form>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            onClick={() => GetMovFilter(id_item)}
          >
            <i className="bi bi-funnel"></i>{' '}
            {loading ? <>Filtrando... {<TelaDeLoading />}</> : <>Filtrar</>}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <h1>Timeline Modal</h1>
            <Button variant="primary" onClick={handleShowModal}>
                Abrir Modal
            </Button> */}

      <Modal
        show={showModalCusto}
        onHide={handleCloseModalCusto}
        size="lg"
        className="timeline-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Alterações de Custo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="timeline">
            {apiResult.map((item, index) => (
              <div
                key={index}
                className="timeline-item"
              >
                <div className="timeline-badge"></div>
                <div className="timeline-content">
                  <h4 className="timeline-title">
                    {item.CUSTO !== null
                      ? item.CUSTO.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })
                      : 'Custo não disponível'}
                  </h4>
                  <p className="timeline-text">{item.PEDIDO_NFE}</p>
                  <p className="timeline-subtitle">
                    {item.NOMEFUNCIONARIO} -{' '}
                    {new Date(item.DATA_MOV).toLocaleDateString('pt-BR')}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseModalCusto}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
export default EstoqueProduto
